<template>
  <step-title
    :title="$t('checkout.select_variant')"
    :smaller="smaller"
    :step-color="stepColor"
    :step="step" />
</template>

<script>
import StepTitle from "./StepTitle";

export default {
  name: "VariantTitle",
  components: {StepTitle},
  props: {
    step: {
      type: Number,
      default: null
    },
    smaller: {
      type: Boolean,
      required: false,
      default: false
    },
    stepColor: {
      type: String,
      required: false,
      default: 'inherit'
    }
  }
}
</script>

<style scoped lang="scss">

</style>